import React, { useEffect, useState } from 'react';
import Table from '../common/Table';
import tableConfig, { data, } from './config';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { GET_SELLERS } from '../../constants';
import { toast } from 'react-toastify';
import { withRouter } from 'react-router-dom';
import { deleteseller, getKYCList, kycApproval, updateSellerDiscount, updateSellerStatus } from '../../actions/chefsandrestaurants';
import Loader from '../common/Loader';
import { withStyles } from '@material-ui/core/styles';
import Button from '../common/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import MuiDialogActions from '@material-ui/core/DialogActions';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import { Checkbox, FormControl, FormControlLabel, FormGroup, FormLabel } from '@material-ui/core';
import { CsvBuilder } from 'filefy';
import "./ChefsAndRestaurants.css";
import { useSelector } from 'react-redux';


const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),

  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});
const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
    minWidth: 500,

  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

const RejectReasonDialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
    justifyContent: "flex-start"
  },
}))(MuiDialogActions);

const GreenCheckbox = withStyles({
  root: {
    '&$checked': {
      color: '#43a047',
    },
  },
  checked: {},
})((props) => <Checkbox color="default" {...props} />);

const ChefsAndRestaurants = (props) => {
  const classes = props.classes;
  let config = tableConfig(props);
  //console.log("tableconfig",config.columns[8]);
  //const onVerify = props.passVerify;
  let session = sessionStorage.getItem('user');
  const [countryid, setCountryid] = useState(session ? `${JSON.parse(session).countryId}` : "");
  const [value, setValue] = useState(0);
  const sellerTypes = ['Chef', 'Restaurant'];
  const [isLoading, setLoading] = useState(false);
  const [cheftableKey, setChefTableKey] = useState(1);
  const [restableKey, setResTableKey] = useState(2);
  const [open, setOpen] = useState(false);
  const [discountModal, setDiscountModal] = useState(false);
  const [sefRestaurantDetail, setSefRestaurantDetail] = useState({
    business_name: "",
    seller_id: 0,
    self_pickup_discount: 0,
    delivery_discount: 0,
    min_cart_amount: 0,
    discount_cap_amount: 0
  });

  const [kyc, setKYC] = useState([]);
  const [selectedSellerData, setSelectedSellerData] = useState(null);
  const [errors, setErrors] = useState(null);
  const [rejectReason, setRejectReason] = useState('')
  const [isRejectKycModalOpen, setIsRejectKycModalOpen] = useState(false);
  const [kycDocumentTypes, setKycDocumentTypes] = useState([
    {
      label: "Aadhaar Card Front Side",
      value: "aadhaarcard_front",
      keyName: "aadhaarCardFront"
    },
    {
      label: "Aadhaar Card Back Side",
      value: "aadhaarcard_back",
      keyName: "aadhaarCardBack"
    },
    {
      label: "Food Licence Front Side",
      value: "food_licence_front",
      keyName: "foodLicenceFront"
    }
  ]);
  const [seletedRejectedKYCdocs, setSeletedRejectedKYCdocs] = useState({
    aadhaarCardFront: false,
    aadhaarCardBack: false,
    foodLicenceFront: false,
  })
  const { totalCounts } = useSelector((state) => state.login)

  const { aadhaarCardFront, aadhaarCardBack, foodLicenceFront } = seletedRejectedKYCdocs
  const rejectKycError = [aadhaarCardFront, aadhaarCardBack, foodLicenceFront].filter((v) => v).length !== 1;

  const disableRejectKYC = rejectKycError || (errors && errors.rejectReason && errors.rejectReason.isInvalid)

  const handleChange = (event, newValue) => {
    console.log({ newValue })
    setValue(newValue);
  };

  config.columns[12].render = function (rowData) {
    const className = rowData.approval_status === "approved" ? "approved-button" : rowData.approval_status === "rejected" ? "rejected-button" : ""
    return (
      <>
        {/* <button className={`verifybutton text-capitalize ${className}`} onClick={() => { onverify(rowData) }}>{(rowData.approval_status === "pending") ? 'Verify KYC' : rowData.approval_status === "rejected" ? 'Rejected' : 'KYC Docs'}</button> */}
        <button className={`verifybutton text-capitalize ${className}`} onClick={() => { onverify(rowData) }}>{rowData.approval_status}</button>
      </>
    );
  }

  config.columns[13].render = function (rowData) {
    const className = rowData.status ? "approved-button" : "rejected-button"
    return (
      <>
        <button
          className={`verifybutton text-capitalize ${className}`}
          onClick={() => { updateActivateStatus(rowData) }}>
          {rowData.status ? "Active" : "Inactive"}
        </button>
      </>
    );
  }

  const onverify = (seller_data) => {
    setKYC(seller_data && seller_data.food_seller_id_proofs ? seller_data.food_seller_id_proofs : '');
    setSelectedSellerData(seller_data);
    setOpen(true);
  }

  const onHandleClickDiscountModal = () => {
    setDiscountModal(true);
  }
  const onHandleClickDiscountModalClose = () => {
    setDiscountModal(false);
    setSefRestaurantDetail({
      business_name: "",
      seller_id: 0,
      self_pickup_discount: 0,
      delivery_discount: 0,
      min_cart_amount: 0,
      discount_cap_amount: 0
    })
  }

  const onView = (rowdata) => {
    if (rowdata.seller_type == "Chef") {
      // props.history.push(`/chef/${rowdata.seller_id}`)
      window.open(`/chef/${rowdata.seller_id}`, '_blank');
    } else if (rowdata.seller_type == "Restaurant") {
      // props.history.push(`/restaurant/${rowdata.seller_id}`);
      window.open(`/restaurant/${rowdata.seller_id}`, '_blank');
    }

    //props.onView() 
  };


  const onButton = (rowdata) => {
    // console.log({ rowdata })
    setSefRestaurantDetail((prevState) => ({
      ...prevState,
      business_name: rowdata.business_name,
      seller_id: rowdata.seller_id,
      self_pickup_discount: rowdata.self_pickup_discount,
      delivery_discount: rowdata.delivery_discount,
      min_cart_amount: rowdata.min_cart_amount,
      discount_cap_amount: rowdata.discount_cap_amount
    }))
    onHandleClickDiscountModal();
  }

  const onDelete = async (rowdata) => {
    try {
      setLoading(true);

      const response = await deleteseller(rowdata.seller_id)
      if (response && response.data) {
        toast.success(response.data.ResponseText || "Seller deleted successfully.");
        updateTableKey()
      }

      setLoading(false);
    } catch (error) {
      toast.error(error.message || "Error while deleting seller");
    }
  }

  const updateActivateStatus = async (rowdata) => {
    try {
      setLoading(true);

      const statusPayload = {
        status: !rowdata.status
      }

      const updateStatusResponse = await updateSellerStatus(rowdata.seller_id, statusPayload)
      if (updateStatusResponse && updateStatusResponse.data) {
        toast.success(updateStatusResponse.data.ResponseText || "Seller status updated successfully.");
        updateTableKey()
      }

      setLoading(false);
    } catch (error) {
      toast.error(error.message || "Error while updating status of seller");
    }
  }

  const handleClose = () => {
    setKYC([])
    setSelectedSellerData(null);
    setOpen(false);
  };

  const updateKYCStatus = async (status) => {
    try {
      const errorData = {}
      const sellerId = selectedSellerData && selectedSellerData.seller_id
      const kycStatusData = { approval_status: status }

      if (status === 'rejected') {
        if (!rejectReason) {
          errorData.rejectReason = {
            isInvalid: true,
            message: "KYC Rejection reason is required."
          }
        }

        const rejectedDocs = []
        kycDocumentTypes.forEach((kycDocumentType) => {
          if (seletedRejectedKYCdocs[kycDocumentType.keyName]) {
            rejectedDocs.push(kycDocumentType.value)
          }
        })

        if (rejectedDocs.length === 0) {
          errorData.seletedRejectedKYCdocs = {
            isInvalid: true,
            message: "Select rejected document type."
          }
        }

        setErrors(errorData)

        if (Object.keys(errorData).length > 0) {
          return
        }

        kycStatusData.proof_reject_reason = rejectReason
        kycStatusData.rejected_doc_names = rejectedDocs.join(", ")
      }

      setErrors(errorData)
      setLoading(true);

      const kycStatusRes = await kycApproval(sellerId, kycStatusData)
      toast.success(kycStatusRes.data.ResponseText || "KYC status updated succesfully");

      if (status === 'rejected') {
        resetRejectModalData()
      }

      updateTableKey()

      setLoading(false);
      setOpen(false);
    } catch (error) {
      toast.error(error.message || "Kyc status update failed");
      console.log(error);
    }
  };

  const updateTableKey = () => {
    // update key to reload data from table though API 
    if (value === 1) {
      setResTableKey(restableKey + 1)
    } else {
      setChefTableKey(cheftableKey + 1)
    }
  }

  const resetRejectModalData = () => {
    setErrors({})
    setRejectReason("")
    setSeletedRejectedKYCdocs({
      aadhaarCardFront: false,
      aadhaarCardBack: false,
      foodLicenceFront: false,
    })
    setIsRejectKycModalOpen(false)
  }

  const handleReasonChange = (e) => {
    setRejectReason(e.target.value)
  };

  const toggleRejectKYCModal = () => {
    try {
      if (isRejectKycModalOpen) {
        resetRejectModalData()
      } else {
        setIsRejectKycModalOpen(!isRejectKycModalOpen)
      }

    } catch (error) {
      console.log(error);
    }
  }

  const handleRejectKYCDocTypes = (event) => {
    setSeletedRejectedKYCdocs({
      ...seletedRejectedKYCdocs,
      [event.target.name]: event.target.checked
    })
  }

  const onHandleClickDiscountSubmit = async () => {
    if (sefRestaurantDetail.seller_id) {
      const discountPayload = {
        self_pickup_discount: sefRestaurantDetail.self_pickup_discount,
        delivery_discount: sefRestaurantDetail.delivery_discount,
        min_cart_amount: sefRestaurantDetail.min_cart_amount,
        discount_cap_amount: sefRestaurantDetail.discount_cap_amount
      }
      const updateStatusResponse = await updateSellerDiscount(sefRestaurantDetail.seller_id, discountPayload)
      if (updateStatusResponse && updateStatusResponse.data) {
        toast.success(updateStatusResponse.data.ResponseText || "Seller discount updated successfully.");
        onHandleClickDiscountModalClose()
        handleChange(0, 1)
        handleChange(0, 0)
      }
    }
  }

  const handleInputChange = (event) => {
    const { value, name } = event.target
    if (name == "min_cart_amount") {
      if (value >= 10000) {
        return false
      }
    } else {
      if (value >= 100) {
        return false
      }
    }
    setSefRestaurantDetail((prevState) => ({ ...prevState, [name]: value }))
  }

  const exportCsv = (columns, data) => {
    const columnTitles = columns.map(columnDef => columnDef.title);
    const csvExportData = []
    const orderFileds = [
      { name: 'seller_type', subField: "" },
      { name: 'business_name', subField: "" },
      { name: 'user', subField: "email_id" },
      { name: 'user', subField: "mobile_no" },
      { name: 'food_seller_cuisine_mappings', subField: "" },
      { name: 'rating', subField: "" },
      { name: 'address_line1', subField: "" },
      { name: 'user', subField: "country", subField2: "country_name" },
      { name: 'approval_status', subField: "" },
    ]

    const ordersData = data.map(order => {
      const ordersDataDetails = []
      const orderData = orderFileds.map((orderFiled) => {
        let orderValue = order[orderFiled.name]
        if (orderFiled.subField && orderValue) {
          orderValue = order[orderFiled.name] && order[orderFiled.name][orderFiled.subField]

          if (orderFiled.subField2 && orderValue) {
            orderValue = order[orderFiled.name] && order[orderFiled.name][orderFiled.subField] && order[orderFiled.name][orderFiled.subField][orderFiled.subField2]
          }
        }

        if (orderFiled.name === "food_seller_cuisine_mappings") {
          return orderValue.map((cuisineData) => cuisineData.cuisine ? cuisineData.cuisine.cuisine_name : '').join(", ")
        }

        return orderValue
      })

      ordersDataDetails.push(...orderData)
      return ordersDataDetails
    })

    const fileName = value === 0 ? "Chefs.csv" : "Restaurants.csv"
    csvExportData.push(...(ordersData || []))
    const builder = new CsvBuilder(fileName)
      .setColumns(columnTitles)
      .addRows(csvExportData);

    builder.exportFile()

    return builder;
  }

  return (<div>
    <Tabs value={value} onChange={handleChange} classes={{ root: classes.tabRoot }}>
      <Tab label={`Chefs ${totalCounts.chefs > 0 ? `(${totalCounts.chefs})` : ""}`} />
      <Tab label={`Restaurants ${totalCounts.resturants > 0 ? `(${totalCounts.resturants})` : ""}`} />
    </Tabs>
    <div className='chefs-restaurants-table-wrapper'>
      {
        value === 0
        && <Table
          key={cheftableKey}
          noBorder={true}
          tableConfig={config}
          data={data}
          onView={onView}
          onButton={onButton}
          // onDelete={onDelete}
          // onVerify={onVerify}
          pageSize={5}
          countryid={countryid}
          apidata="sellers"
          url={GET_SELLERS}
          extraQueryParam={["seller_type=Chef"]}
          exportCsv={exportCsv}
        />
      }
    </div>
    <div className='chefs-restaurants-table-wrapper'>
      {value === 1
        && <Table
          key={restableKey}
          noBorder={true}
          tableConfig={config}
          data={data}
          onView={onView}
          // onDelete={onDelete}
          // onVerify = {onVerify}
          pageSize={5}
          apidata="sellers"
          countryid={countryid}
          url={GET_SELLERS}
          extraQueryParam={["seller_type=Restaurant"]}
          exportCsv={exportCsv}
        />
      }
    </div>

    <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={open} scroll={'body'}>
      <DialogTitle id="customized-dialog-title" onClose={handleClose}>
        KYC Verification
      </DialogTitle>
      <DialogContent dividers>
        <Typography gutterBottom>
          {kyc != "" &&
            <table border="1" cellPadding="10" cellSpacing="5" width="100%" style={{ textAlign: "center" }}>
              <thead>
                <tr>
                  <th>KYC Name</th>
                  <th>Front Side</th>
                  <th>Back Side</th>
                </tr>
              </thead>
              <tbody>
                {kyc != "" && kyc.map((kycdet) => (
                  <tr>
                    <td>{kycdet.proof_name ? kycdet.proof_name : "-"}</td>
                    <td><img src={kycdet.front_url} width="200" height="200"></img><br></br><a href={kycdet.front_url ? kycdet.front_url : ""} target="_blank"><span style={{ textDecoration: "underline", color: "blue" }}>View KYC of {kycdet.proof_name}</span></a></td>
                    {
                      kycdet.back_url ?
                        <td><img src={kycdet.back_url} width="200" height="200"></img><br></br><a href={kycdet.back_url ? kycdet.back_url : ""} target="_blank"><span style={{ textDecoration: "underline", color: "blue" }}>View KYC of {kycdet.proof_name}</span></a></td>
                        : null
                    }
                  </tr>
                ))}
              </tbody>
            </table>
          }
          {kyc && kyc.length === 0 && <div>KYC Documents not available.</div>}
        </Typography>
      </DialogContent>
      {(kyc && kyc.length > 0 && selectedSellerData && selectedSellerData.approval_status && selectedSellerData.approval_status === "rejected")
        &&
        <RejectReasonDialogActions>
          <div className='kyc-update-buttons-container'>
            <div style={{ color: "red" }}>Rejected Documents :
              {
                selectedSellerData.rejected_doc_names && selectedSellerData.rejected_doc_names.split(", ").map((rejectedDoc) => {
                  const docData = kycDocumentTypes.find((docType) => docType.value === rejectedDoc)
                  return docData && docData.label
                }).join(", ")
              }</div>
            <div style={{ textAlign: "center", color: "red" }}>Document Reject Reason : {selectedSellerData.proof_reject_reason || 'Uploaded documents are rejected by admin.'}</div>
          </div>
        </RejectReasonDialogActions>
      }
      {
        (kyc && kyc.length > 0 && selectedSellerData && selectedSellerData.approval_status && selectedSellerData.approval_status === "approved") ? (
          <div className='kyc-update-buttons-container approved' style={{ color: '#28a745' }}>Documents are Approved.</div>
        ) : ""
      }
      {
        (kyc && kyc.length > 0)
        &&
        <DialogActions>
          <Button label={'Approve'} autoFocus onClick={() => { updateKYCStatus("approved") }} color="primary" />
          <Button label={'Reject'} autoFocus onClick={toggleRejectKYCModal} color="primary" />
        </DialogActions>
      }
    </Dialog >

    <Dialog
      onClose={toggleRejectKYCModal}
      aria-labelledby="reject-kyc-reason-modal"
      open={isRejectKycModalOpen}
      scroll={'body'}>
      <DialogTitle id="reject-kyc-reason-modal" onClose={toggleRejectKYCModal}>
        KYC Reject Reason
      </DialogTitle>
      <DialogContent dividers>
        <FormControl required error={rejectKycError} component="fieldset">
          <FormLabel component="legend">Select documents which are not valid</FormLabel>
          <FormGroup className='ml-4'>
            {kycDocumentTypes && kycDocumentTypes.map((kycDocumentType, kycDocumentTypeIndex) => {
              return (
                <FormControlLabel
                  control={
                    <GreenCheckbox
                      size="small"
                      name={kycDocumentType.keyName}
                      checked={seletedRejectedKYCdocs[kycDocumentType.keyName]} />}
                  name="document_types"
                  id={kycDocumentTypeIndex}
                  label={kycDocumentType.label}
                  onChange={(e) => handleRejectKYCDocTypes(e)}
                />
              );
            })}
          </FormGroup>
        </FormControl>
        <TextField
          label="Reject Reason"
          name="rejectReason"
          placeholder="Enter Reject Reason"
          onChange={(event) => handleReasonChange(event)}
          variant="outlined"
          value={rejectReason || ''}
          error={errors && errors.rejectReason && errors.rejectReason.isInvalid}
          helperText={errors && errors.rejectReason && errors.rejectReason.isInvalid && errors.rejectReason.message}
        />
      </DialogContent>
      <DialogActions>
        <Button label={'Cancel'} onClick={toggleRejectKYCModal} color="primary" />
        <Button
          label={'Submit'}
          autoFocus
          disabled={disableRejectKYC}
          onClick={() => { updateKYCStatus("rejected") }} color="primary" />
      </DialogActions>
    </Dialog>

    {/* discount modal */}
    <Dialog onClose={onHandleClickDiscountModalClose} aria-labelledby="customized-dialog-title" open={discountModal} scroll={'body'} className="add-discount-modal">
      <DialogTitle id="customized-dialog-title" onClose={onHandleClickDiscountModalClose}>
        Edit Discount
      </DialogTitle>
      <DialogContent>
        <div className='discount-modal-wrap'>
          <span className='d-flex align-items-center justify-content-center mb-3'><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="100" height="100"><path d="M10.0544 2.0941C11.1756 1.13856 12.8248 1.13855 13.9461 2.09411L15.2941 3.24286C15.4542 3.37935 15.6533 3.46182 15.8631 3.47856L17.6286 3.61945C19.0971 3.73663 20.2633 4.9028 20.3805 6.37131L20.5214 8.13679C20.5381 8.34654 20.6205 8.54568 20.757 8.70585L21.9058 10.0539C22.8614 11.1751 22.8614 12.8243 21.9058 13.9456L20.757 15.2935C20.6206 15.4537 20.538 15.6529 20.5213 15.8627L20.3805 17.6281C20.2633 19.0967 19.0971 20.2628 17.6286 20.3799L15.8631 20.5208C15.6533 20.5376 15.4542 20.6201 15.2941 20.7566L13.9461 21.9053C12.8248 22.8609 11.1756 22.8608 10.0543 21.9053L8.70631 20.7566C8.54615 20.6201 8.34705 20.5376 8.1373 20.5209L6.37184 20.3799C4.9033 20.2627 3.73716 19.0966 3.61997 17.6281L3.47906 15.8627C3.46232 15.6529 3.37983 15.4538 3.24336 15.2936L2.0946 13.9455C1.13905 12.8243 1.13904 11.1752 2.09458 10.0539L3.24334 8.70589C3.37983 8.54573 3.46234 8.34654 3.47907 8.13678L3.61996 6.3713C3.73714 4.90278 4.90327 3.73665 6.3718 3.61946L8.13729 3.47857C8.34705 3.46183 8.54619 3.37935 8.70636 3.24286L10.0544 2.0941ZM12.6488 3.61632C12.2751 3.29782 11.7253 3.29781 11.3516 3.61632L10.0036 4.76509C9.5231 5.17456 8.92568 5.42201 8.29637 5.47223L6.5309 5.61312C6.04139 5.65219 5.65268 6.04089 5.61362 6.53041L5.47272 8.29593C5.4225 8.92521 5.17505 9.52259 4.76559 10.0031L3.61683 11.3511C3.29832 11.7248 3.29831 12.2746 3.61683 12.6483L4.76559 13.9963C5.17506 14.4768 5.4225 15.0743 5.47275 15.7035L5.61363 17.469C5.65268 17.9585 6.04139 18.3473 6.53092 18.3863L8.29636 18.5272C8.92563 18.5774 9.5231 18.8249 10.0036 19.2344L11.3516 20.3831C11.7254 20.7016 12.2751 20.7016 12.6488 20.3831L13.9969 19.2343C14.4773 18.8249 15.0747 18.5774 15.704 18.5272L17.4695 18.3863C17.959 18.3472 18.3478 17.9585 18.3868 17.469L18.5277 15.7035C18.5779 15.0742 18.8253 14.4768 19.2349 13.9964L20.3836 12.6483C20.7022 12.2746 20.7021 11.7249 20.3836 11.3511L19.2348 10.0031C18.8253 9.52259 18.5779 8.92519 18.5277 8.2959L18.3868 6.53041C18.3478 6.0409 17.959 5.65219 17.4695 5.61312L15.704 5.47224C15.0748 5.42203 14.4773 5.17455 13.9968 4.76508L12.6488 3.61632ZM14.8284 7.75718L16.2426 9.1714L9.17154 16.2425L7.75733 14.8282L14.8284 7.75718ZM10.2322 10.232C9.64641 10.8178 8.69667 10.8178 8.11088 10.232C7.52509 9.6463 7.52509 8.69652 8.11088 8.11073C8.69667 7.52494 9.64641 7.52494 10.2322 8.11073C10.818 8.69652 10.818 9.6463 10.2322 10.232ZM13.7677 15.8889C14.3535 16.4747 15.3032 16.4747 15.889 15.8889C16.4748 15.3031 16.4748 14.3534 15.889 13.7676C15.3032 13.1818 14.3535 13.1818 13.7677 13.7676C13.1819 14.3534 13.1819 15.3031 13.7677 15.8889Z"></path></svg></span>
          <div className='form-group'>
            <label className='mb-0'>Chef/Restaurant name :-</label>
            <h2>{sefRestaurantDetail.business_name}</h2>
          </div>
          {sefRestaurantDetail &&
            <>
              <div className='form-group'>
                <label className='d-block mb-2'>Self-Pick up Discount Percentage :-</label>

                <TextField
                  type="number"
                  name="self_pickup_discount"
                  placeholder="Please enter self pickup discount"
                  className="form-control custom-input"
                  variant="outlined"
                  onChange={handleInputChange}
                  value={sefRestaurantDetail.self_pickup_discount || ""}
                  InputProps={{
                    inputProps: {
                      max: 100, min: 10
                    }
                  }}
                />
              </div>
              <div className='form-group'>
                <label className='d-block mb-2'>Delivery Discount Percentage :-</label>
                <TextField
                  type="number"
                  name="delivery_discount"
                  placeholder="Please enter delivery discount"
                  className="form-control custom-input"
                  variant="outlined"
                  onChange={handleInputChange}
                  max={100}
                  value={sefRestaurantDetail.delivery_discount || ""} />
              </div>
              <div className='form-group'>
                <label className='d-block mb-2'>Minimum Cart Value :-</label>
                <TextField
                  type="number"
                  name="min_cart_amount"
                  placeholder="Please enter min cart amount"
                  className="form-control custom-input"
                  variant="outlined"
                  onChange={handleInputChange}
                  max={100000}
                  value={sefRestaurantDetail.min_cart_amount || ""} />
              </div>
              <div className='form-group'>
                <label className='d-block mb-2'>Max discount allowed :-</label>
                <TextField
                  type="number"
                  name="discount_cap_amount"
                  placeholder="Please enter discount cap amount"
                  className="form-control custom-input"
                  variant="outlined"
                  onChange={handleInputChange}
                  max={100}
                  value={sefRestaurantDetail.discount_cap_amount || ""} />
              </div>
              <div className='d-flex align-items-center gap-20'>
                <button className="btn ant-btn-primary" type="button" onClick={() => onHandleClickDiscountSubmit()}>Submit</button>
                <button className="btn outline-primary" type="button" onClick={() => onHandleClickDiscountModalClose()}>Cancel</button>
              </div>
            </>
          }
        </div>
      </DialogContent>
    </Dialog >
  </div >
  )
};

export default withRouter(ChefsAndRestaurants);
